/**
 * Where the shared AudioManager lives, and how a scene gets at it.
 *
 * Separate from AudioManager itself so scenes can reach the instance without
 * importing the Web Audio code, and so a scene running before Boot (or in a
 * test) gets a harmless null rather than a crash.
 */
import type Phaser from 'phaser';
import type { AudioManager } from './AudioManager';

export const AUDIO_REGISTRY = 'audio';

export function audioOf(scene: Phaser.Scene): AudioManager | null {
  const found: unknown = scene.registry.get(AUDIO_REGISTRY);
  return found === null || found === undefined ? null : (found as AudioManager);
}
